import { useContext } from 'react'

import { FrameBuilderSelectionContext } from '../../contexts/selection-context'
import { FrameBuilderStringsContext } from '../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import ConfigurationStepPreview, {
  type StepPreviewProps,
} from './configuration-step-preview'

const FrameStyleStepPreview = ({ number, onClick }: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation, validationMessages } = useContext(
    FrameBuilderValidationContext,
  )

  return (
    <ConfigurationStepPreview
      step="frameStyle"
      title={frameBuilderStrings.frameStyleStepTitle}
      value={committedStateSelectionMessages?.frameStyle}
      error={
        validationMessages?.frameStyleProfilePreview ||
        validationMessages?.frameStyleTexturePreview
      }
      placeholder={frameBuilderStrings.frameStylePlaceholder}
      opacity={stepPreviewAnimation.frameStyleOpacity}
      number={number}
      onClick={onClick}
      className="grow-0 shrink-0"
    />
  )
}

export default FrameStyleStepPreview
